import { render, staticRenderFns } from "./editPhotogallary.vue?vue&type=template&id=3d91054e&scoped=true"
import script from "./editPhotogallary.vue?vue&type=script&lang=js"
export * from "./editPhotogallary.vue?vue&type=script&lang=js"
import style0 from "./editPhotogallary.vue?vue&type=style&index=0&id=3d91054e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91054e",
  null
  
)

export default component.exports